export const types = {
    GET_WEIGHTOFINVOICEITEMS: "GET_WEIGHTOFINVOICEITEMS",
    GET_WEIGHTOFINVOICEITEMS_SUCCESS: "GET_WEIGHTOFINVOICEITEMS_SUCCESS",

    LOAD_OPTIMIZATION_DATA_ACCESS:"LOAD_OPTIMIZATION_DATA_ACCESS",
    LOAD_OPTIMIZATION_DATA_ACCESS_SUCCESS:"LOAD_OPTIMIZATION_DATA_ACCESS_SUCCESS"
  };
  